import { SurveyComponent } from "../../survey_component";
import env from "../../../../env";

const required = env.ENDPOINT !== "local";

export const HouseRoomAmount = new SurveyComponent({
  name: "house_room_amount",
  type: "text",
  inputType: "number",
  isRequired: required,
  title: {
    en: "No. of Rooms (without kitchen) *",
    ar: "عدد الغرف (بدون مطبخ) *"
  }
});
